<template>
  <div class="phone-progress">
    <div class="progress-track">
      <div
        :style="{ height: ratio + '%' }"
        :class="['progress-slider', ratio < 60 ? 'bgc-FF3C30' : ratio < 85 ? 'bgc-FFB032' : 'bgc-1DC060']"
      />
    </div>
    <div class="word-char">/{{ phonemeContrastEnum[content] || '' }}/</div>
  </div>
</template>

<script>
import { PhonemeContrastEnum } from '@/utils/dictionary'

export default {
  name: 'PhoneProgress',
  props: {
    // 进度比例
    ratio: {
      type: Number,
      default: () => 0
    },
    // 显示说明
    content: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      phonemeContrastEnum: PhonemeContrastEnum
    }
  }
}
</script>

<style lang="scss" scoped>
.phone-progress {
  width: 34px;
  max-width: 34px;
  .progress-track {
    width: 8px;
    height: 60px;
    margin: 0 auto;
    border-radius: 4px;
    background-color: #e5e5e5;
    position: relative;
    .progress-slider {
      width: 8px;
      border-radius: 4px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .word-char {
    width: 34px;
    color: #333333;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
  }
}
</style>
